import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';

import { Loader } from '@bitstopco/bitstop-theme';
import { IconButton } from '@mui/material';

import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { useRemoveAffiliateMachinesMutation } from '@/store/api/services/affiliates/affiliates';

import { getOperatorId } from '@/helpers/jwt';

import type { AffiliateAtmListView } from '@/types';

interface AffiliateMachinesRemoveColumnProps {
  value: Pick<AffiliateAtmListView, 'id'>;
}

export const AffiliateMachinesRemoveColumn = ({ value }: AffiliateMachinesRemoveColumnProps) => {
  const { id: affiliateId } = useParams();
  const [removeMachines, { isLoading }] = useRemoveAffiliateMachinesMutation();

  const handleRemove = async () => {
    if (!affiliateId) {
      return;
    }

    try {
      await removeMachines({
        operator_id: getOperatorId(),
        affiliate_id: affiliateId,
        atm_ids: [value.id],
      }).unwrap();

      toast.success(`Atm ${value.id} removed successfully`);
    } catch {}
  };

  return (
    <IconButton onClick={handleRemove} disabled={isLoading || !affiliateId}>
      {isLoading ? <Loader size={16} /> : <DeleteOutlineIcon />}
    </IconButton>
  );
};
